import script from "./Legals.vue?vue&type=script&setup=true&lang=js"
export * from "./Legals.vue?vue&type=script&setup=true&lang=js"

import "./Legals.vue?vue&type=style&index=0&id=bb1bf05c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb1bf05c"]])

export default __exports__